import { atom } from 'jotai';

import {
  type ExportCopySettingsSnapshot,
  type ExportFontOptions,
} from '../contracts/export-files/exportFonts';

/** Relayed export analytics; shared with `useExportAs` so the shapes stay identical. */
export type ExportFontAnalytics = {
  sessionId: string;
  documentId: string;
  settingsPipeline?: 'toggles' | 'legacy';
  copySettings?: ExportCopySettingsSnapshot;
};

/**
 * A pending PDF/DOCX export awaiting the user's font + size choice. Export
 * entry points (More menu, V2 export row, action center) set this atom instead
 * of exporting immediately; `ExportFontModal` reads it, collects the font/size,
 * runs the export, then clears it.
 */
export interface ExportFontRequest {
  type: 'PDF' | 'DOCX';
  content: string;
  fileName: string;
  analytics: ExportFontAnalytics;
  /**
   * Fired after a successful export. Receives the applied font options when a
   * font was applied (picker or saved default), or `undefined` on the legacy
   * path (feature flag off). Used by callers that need extra side effects
   * (e.g. action-center analytics) that previously chained off `handleExportAs`.
   */
  onExported?: (fontOptions?: ExportFontOptions) => void;
}

export const exportFontModalAtom = atom<ExportFontRequest | null>(null);
